import { render, staticRenderFns } from "./ModalBtn.vue?vue&type=template&id=5d2ec648&scoped=true&"
import script from "./ModalBtn.vue?vue&type=script&lang=js&"
export * from "./ModalBtn.vue?vue&type=script&lang=js&"
import style0 from "./ModalBtn.vue?vue&type=style&index=0&id=5d2ec648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2ec648",
  null
  
)

export default component.exports